import React from 'react';
import { motion } from 'framer-motion';
import { HiOutlineSparkles } from 'react-icons/hi';
import { useLanguage } from '../../contexts/LanguageContext';

const MobileBanner = React.memo(() => {
  const { t } = useLanguage();

  return (
    <section className="block">
      <div
        className="relative z-[2] overflow-hidden bg-banner px-4 py-3"
      >
        {/* Subtle decorative circles */}
        <div
          className="absolute -top-6 -right-6 w-24 h-24 rounded-full opacity-[0.12]"
          style={{ background: 'radial-gradient(circle, #FFFFFF 0%, transparent 70%)' }}
        />
        <div
          className="absolute -bottom-4 -left-4 w-16 h-16 rounded-full opacity-[0.08]"
          style={{ background: 'radial-gradient(circle, #FFFFFF 0%, transparent 70%)' }}
        />

        <motion.div
          className="relative flex items-center gap-3"
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
        >
          <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-white/15 ring-1 ring-inset ring-white/20 flex-shrink-0">
            <HiOutlineSparkles className="w-4 h-4 text-white" />
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-white text-sm font-semibold leading-tight truncate">
              {t('login.rightSide.welcome')} Dreirosen Apotheke
            </p>
            <p className="text-white/75 text-xs font-medium mt-0.5 truncate">
              {t('login.rightSide.subtitle')}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
});

MobileBanner.displayName = 'MobileBanner';

export default MobileBanner;
